import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Config from './components/Config';
import GitHubAuthPage from './components/GitHubAuthPage';
import Dashboard from './components/Dashboard';
import IssuePanel from './components/IssuePanel';

const App = () => (
  <Router>
    <Routes>
      <Route path="/issue-panel" element={<IssuePanel />} />
      <Route path="/config" element={<Config />} />
      <Route path="/github-auth" element={<GitHubAuthPage />} />
      <Route path="/dashboard" element={<Dashboard />} />
    </Routes>
  </Router>
);

const root = ReactDOM.createRoot(document.getElementById('root'));

// Wrap the rendering in AP.context.getContext
if (window.AP) {
  window.AP.context.getContext(() => {
    root.render(<App />);
  });
} else {
  // Fallback for local development
  root.render(<App />);
}
